__turbopack_context__.v({
  "batStyle": "PlayerList-module-scss-module__vaTeAa__batStyle",
  "captainTag": "PlayerList-module-scss-module__vaTeAa__captainTag",
  "countryCode": "PlayerList-module-scss-module__vaTeAa__countryCode",
  "countryInfo": "PlayerList-module-scss-module__vaTeAa__countryInfo",
  "flagIcon": "PlayerList-module-scss-module__vaTeAa__flagIcon",
  "player-info-desktop": "PlayerList-module-scss-module__vaTeAa__player-info-desktop",
  "playerInfo": "PlayerList-module-scss-module__vaTeAa__playerInfo",
  "playerListContainer": "PlayerList-module-scss-module__vaTeAa__playerListContainer",
  "playerName": "PlayerList-module-scss-module__vaTeAa__playerName",
  "playerRow": "PlayerList-module-scss-module__vaTeAa__playerRow",
  "role": "PlayerList-module-scss-module__vaTeAa__role",
});
